import { render } from "./WeatherQualities.vue?vue&type=template&id=c2f04b50&scoped=true"
import script from "./WeatherQualities.vue?vue&type=script&lang=js"
export * from "./WeatherQualities.vue?vue&type=script&lang=js"

import "./WeatherQualities.vue?vue&type=style&index=0&id=c2f04b50&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f04b50"]])

export default __exports__